import {
  Component,
  OnInit,
  ElementRef,
  HostListener,
  inject,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { MdlManageBudget } from '../../components/mdl-manage-budget/mdl-manage-budget';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { MdlChangeBudgetComponent } from '../../components/mdl-change-budget/mdl-change-budget';
import { MdlCreateUserComponent } from '../../components/mdl-create-user/mdl-create-user';
import { MdlDeleteUserComponent } from '../../components/mdl-delete-user/mdl-delete-user';
import { MdlFilterUsers } from '../../components/mdl-filter-users/mdl-filter-users';
import { SessionService } from '../../services/session.service';
import { PermisoConfig, PERMISSIONS_CONFIG } from '../../services/permission.config';
import { Subscription } from 'rxjs'; 
import { MdlUnlinkOutlook } from '../../components/mdl-unlink-outlook/mdl-unlink-outlook';
import { AlertService } from '../../services/alert.service';


@Component({
  selector: 'app-user-table',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './user-table.html',
  styleUrls: ['./user-table.css'],
})
export class UserTable implements OnInit, OnDestroy {
  modulos = PERMISSIONS_CONFIG;
  permisosUsuario: Record<string, Record<string, boolean>> = {};

  primerosModulos: PermisoConfig[] = this.modulos.slice(0, 5); 

  usuarios: any[] = [];
  usuariosFiltrados: any[] = [];
  isLoading: boolean = true;
  errorMessage: string = '';
  showRecentDropdown: boolean = false;
  selectedItem: string = 'todos';
  openedMenuId: string | null = null;
  searchTerm: string = '';
  mostrarTabla: boolean = false;
  vistaActual: string = '';
  usuariosOriginales: any[] = [];
  mostrarModificarUsuario: boolean = false;
  usuarioSeleccionado: any = null;
  usuariosSeleccionados: number = 0;
  showActionsDropdown: boolean = false;
  usuariosConSeleccion: Set<string> = new Set();
  contrasenaActual: string = '';
  nuevaContrasena: string = '';
  confirmarContrasena: string = '';
  mostrarRequisitos: boolean = false;
  cumpleLongitud: boolean = false;
  cumpleMayuscula: boolean = false;
  cumpleNumero: boolean = false;
  cumpleEspecial: boolean = false;
  contrasenasCoinciden: boolean = false;
  formularioContrasenaValido: boolean = false;
  usuarioActivo: any = null;
  emailUsuario: string = '';
  nombreUsuario: string = '';
  apellidoUsuario: string = '';
  rutUsuario: string = '';
  rolUsuario: string = '';
  fechaCreacionUsuario: Date = new Date();
ultimoCambioContrasena: Date | null = null; 
  companiaUsuario: string = 'Siroe';
  departamentoUsuario: string = 'TI';
  rutUsuarioFormateado: string = '';
  rutUsuarioOriginal: string = '';
  contrasenaActualError: string = '';
  ambiandoContrasena: boolean = false;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  activeFilters: any = null;
  outlookMail: string = '';
  rolesDisponibles: any[] = [];

  private datosOriginales: any = {};
  mostrarNuevaContrasena: boolean = false;


  private userDataSubscription: Subscription | null = null;
  private userDataLoadAttempted = false;
  private cargarUsuariosTimeout: any = null;
  private alertService = inject(AlertService);

  menuOpciones = [
    {
      key: 'datos',
      label: 'Datos personales',
      icon: 'assets/svg/edit-data.svg',
    },
    {
      key: 'usuarios',
      label: 'Usuarios',
      icon: 'assets/svg/usert-black-icon.svg',
    },
    {
      key: 'correo',
      label: 'Configuración de correo',
      icon: 'assets/svg/mail-black-icon.svg',
    },
    {
      key: 'cambiar-contrasena',
      label: 'Cambiar contraseña',
      icon: 'assets/svg/settings-black-icon.svg',
    },
  ];

  constructor(
    private api: Api,
    private elementRef: ElementRef,
    private router: Router,
    private sessionService: SessionService,
  ) {}

  readonly dialog = inject(MatDialog);

  ngOnInit(): void {
    this.cargarDatosUsuarioActivo();
    this.initializeFilters();
    this.getOulookMail();
    this.cambiarVista('datos');
    console.log('usuario activo', this.usuarioActivo)
    this.getRoles()
  }

  ngOnDestroy(): void {
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }
    if (this.cargarUsuariosTimeout) {
      clearTimeout(this.cargarUsuariosTimeout);
    }
  }

  private initializeFilters(): void {
    if (!this.activeFilters) {
      this.activeFilters = {
        allRoles: true,
        allStatuses: true,
        lastLogin: 'all',
        roles: {
          administrador: false,
          ejecutivo: false,
          otros: false
        },
        statuses: {
          activo: false,
          inactivo: false
        }
      };
    }
  }

  cargarUsuarios(): void {
    if (this.cargarUsuariosTimeout) {
      clearTimeout(this.cargarUsuariosTimeout);
    }

    if (!this.usuarioActivo) {
      console.log('Esperando datos del usuario activo...');
      
      this.cargarUsuariosTimeout = setTimeout(() => {
        this.cargarUsuarios();
      }, 100);
      return;
    }

    this.limpiarSeleccion();
    this.api.showLoading();
    this.isLoading = true;
    this.errorMessage = '';

    this.api.getUsers().subscribe({
      next: (response: any) => {
        this.usuarios = (response.users || []).map((user: any) => {
          return {
            ...user,
            alias: this.generarAlias(user.nombre, user.apellido),
            estado: user.activo === 1 ? 'Activo' : 'Inactivo',
            perfil: user.rol.name,
            ultimo_login: user.ultimo_login || user.fecha_creacion,
            ultimo_login_formatted: this.formatearFecha(user.ultimo_login || user.fecha_creacion)
          };
        });

        if (this.activeFilters) {
          this.applyAdvancedFilters();
        } else {
          this.usuariosFiltrados = [...this.usuarios];
        }
        console.log(this.usuarios)
        setTimeout(() => {
          this.api.hideLoading();
          this.isLoading = false;
        }, 500);
      },
      error: (error) => {
        console.error('Error al cargar usuarios:', error);
        this.errorMessage = 'Error al cargar los usuarios. Por favor, inténtelo de nuevo más tarde.';
        this.isLoading = false;
        this.api.hideLoading();
      },
    });
  }

  private formatearFecha(fecha: any): string {
    if (!fecha) return 'Sin registro';
    
    try {
      const fechaObj = fecha instanceof Date ? fecha : new Date(fecha);
      if (isNaN(fechaObj.getTime())) return 'Fecha inválida';
      
      return fechaObj.toLocaleString('es-CL', {
        day: '2-digit',
        month: '2-digit', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    } catch (error) {
      console.error('Error al formatear fecha:', error);
      return 'Error en fecha';
    }
  }

  cargarDatosUsuarioActivo(): void {
    console.log("entra funcion cargar datos")
    if (this.userDataLoadAttempted) {

      return;
    }
    
    this.userDataLoadAttempted = true;
    this.api.getUserProfile().subscribe({
      next: (res: any) => {
        this.usuarioActivo = res.data;
        console.log("✅ Usuario activo cargado:", this.usuarioActivo);
        this.procesarDatosUsuario();
        this.cargarUsuarios();
      },
      error: (err) => {
        console.error("❌ Error cargando perfil:", err);
      },
    });

    if (this.usuarioActivo) {
      this.procesarDatosUsuario();
      this.cargarUsuarios(); 
    } else {
      this.userDataSubscription = this.sessionService.userData$.subscribe({
        next: (userData) => {
          if (userData) {
            console.log('✅ user-table: Datos recibidos via Observable');
            this.usuarioActivo = userData;
            console.log('usuario activo',this.usuarioActivo)
            this.procesarDatosUsuario();
            this.cargarUsuarios(); 
            
            if (this.userDataSubscription) {
              this.userDataSubscription.unsubscribe();
              this.userDataSubscription = null;
            }
          }
        },
        error: (error) => {
          console.error('❌ user-table: Error al obtener datos:', error);
          if (this.userDataSubscription) {
            this.userDataSubscription.unsubscribe();
            this.userDataSubscription = null;
          }
        }
      });

      setTimeout(() => {
        if (this.userDataSubscription && !this.usuarioActivo) {
          console.warn('⚠️ user-table: Timeout esperando datos del usuario');
          this.userDataSubscription.unsubscribe();
          this.userDataSubscription = null;
          
          this.usuarioActivo = { compania: 'Siroe', departamento: 'TI' };
          this.procesarDatosUsuario();
          this.cargarUsuarios();
        }
      }, 5000); 
    }
  }

  private procesarDatosUsuario(): void {
    if (!this.usuarioActivo) {
      console.error('❌ user-table: No hay usuario activo para procesar');
      return;
    }

    this.emailUsuario = this.sessionService.getUserEmail() || this.usuarioActivo.email || '';
    this.nombreUsuario = this.usuarioActivo.nombre || '';
    this.apellidoUsuario = this.usuarioActivo.apellido || '';
    this.rutUsuarioOriginal = this.sessionService.getUserRut() || this.usuarioActivo.rut || '';
    
    this.rutUsuarioFormateado = this.rutUsuarioOriginal
      ? this.formatearRUTParaMostrar(this.rutUsuarioOriginal)
      : '';

    this.rolUsuario = this.sessionService.getUserRole() || this.usuarioActivo.rolId || '';
    this.fechaCreacionUsuario = this.usuarioActivo.fecha_creacion;
    this.companiaUsuario = this.usuarioActivo.compania || 'Siroe';
    this.departamentoUsuario = this.usuarioActivo.departamento || 'TI';

 if (this.usuarioActivo?.ultimo_cambio_contrasena) {
  this.ultimoCambioContrasena = new Date(this.usuarioActivo.ultimo_cambio_contrasena);
} else {
  this.ultimoCambioContrasena = null; 
}


  this.usuarioActivo.ultimo_login = this.usuarioActivo.ultimo_login
    ? new Date(this.usuarioActivo.ultimo_login)
    : null;
  }


  openFilterModal(): void {
    const dialogRef = this.dialog.open(MdlFilterUsers, {
      minWidth: '600px',
      maxHeight: '80vh',
      panelClass: 'mat-dlg-class',
      data: this.activeFilters 
    });

    dialogRef.afterClosed().subscribe((filters: any) => {
      if (filters) {
        this.activeFilters = filters;
        this.applyAdvancedFilters();
        this.alertService.success('Filtros aplicados', 'Filtros aplicados correctamente');
      }
    });
  }

  private applyAdvancedFilters(): void {
    let filteredUsers = [...this.usuarios];

    if (!this.activeFilters.allRoles) {
      const selectedRoles = Object.keys(this.activeFilters.roles).filter(key => this.activeFilters.roles[key]);
      if (selectedRoles.length > 0) {
        filteredUsers = filteredUsers.filter(usuario => {
          const userRole = this.mapUserRoleToFilter(usuario.perfil);
          return selectedRoles.includes(userRole);
        });
      }
    }

    if (!this.activeFilters.allStatuses) {
      const selectedStatuses = Object.keys(this.activeFilters.statuses).filter(key => this.activeFilters.statuses[key]);
      if (selectedStatuses.length > 0) {
        filteredUsers = filteredUsers.filter(usuario => {
          const userStatus = usuario.activo === 1 ? 'activo' : 'inactivo';
          return selectedStatuses.includes(userStatus);
        });
      }
    }

    if (this.activeFilters.lastLogin !== 'all') {
      filteredUsers = this.filterByLastLogin(filteredUsers, this.activeFilters.lastLogin);
    }

    this.usuariosFiltrados = filteredUsers;
    
    if (this.sortColumn) {
      this.applySorting();
    }
  }

  private mapUserRoleToFilter(perfil: string): string {
    const roleMap: { [key: string]: string } = {
      'administrator': 'administrador',
      'administrador': 'administrador',
      'admin': 'administrador',
      'ejecutivo comercial': 'ejecutivo',
      'ejecutivo': 'ejecutivo',
      'vendedor': 'ejecutivo'
    };
    
    return roleMap[perfil?.toLowerCase()] || 'otros';
  }

  private filterByLastLogin(users: any[], lastLoginFilter: string): any[] {
    const hoy = new Date();
    
    switch (lastLoginFilter) {
      case '7d':
        const sieteDiasAtras = new Date(hoy);
        sieteDiasAtras.setDate(hoy.getDate() - 7);
        return users.filter(u => {
          if (!u.ultimo_login) return false;
          return new Date(u.ultimo_login) >= sieteDiasAtras;
        });
      
      case '30d':
        const treintaDiasAtras = new Date(hoy);
        treintaDiasAtras.setDate(hoy.getDate() - 30);
        return users.filter(u => {
          if (!u.ultimo_login) return false;
          return new Date(u.ultimo_login) >= treintaDiasAtras;
        });
      
      case 'never':
        return users.filter(u => !u.ultimo_login || u.ultimo_login === 'Sin registro');
      
      default:
        return users;
    }
  }

  sortByColumn(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.applySorting();
  }

  private applySorting(): void {
    if (!this.sortColumn) return;

    this.usuariosFiltrados = [...this.usuariosFiltrados].sort((a, b) => {
      let valueA = a[this.sortColumn];
      let valueB = b[this.sortColumn];

      switch (this.sortColumn) {
        case 'nombre':
          valueA = `${a.nombre} ${a.apellido}`.toLowerCase();
          valueB = `${b.nombre} ${b.apellido}`.toLowerCase();
          break;
        
        case 'ultimo_login':
          valueA = a.ultimo_login ? new Date(a.ultimo_login) : new Date(0);
          valueB = b.ultimo_login ? new Date(b.ultimo_login) : new Date(0);
          break;
        
        case 'perfil':
          valueA = a.perfil?.toLowerCase() || '';
          valueB = b.perfil?.toLowerCase() || '';
          break;
        
        case 'activo':
          valueA = a.activo;
          valueB = b.activo;
          return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
        
        default:
          if (typeof valueA === 'string') {
            valueA = valueA.toLowerCase();
            valueB = valueB.toLowerCase();
          }
      }

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  onSearchChange(): void {
    if (!this.searchTerm.trim()) {
      if (this.activeFilters) {
        this.applyAdvancedFilters();
      } else {
        this.usuariosFiltrados = [...this.usuarios];
      }
    } else {
      const searchLower = this.searchTerm.toLowerCase().trim();
      this.usuariosFiltrados = this.usuarios.filter(usuario => 
        usuario.nombre?.toLowerCase().includes(searchLower) ||
        usuario.apellido?.toLowerCase().includes(searchLower) ||
        usuario.email?.toLowerCase().includes(searchLower) ||
        usuario.alias?.toLowerCase().includes(searchLower) ||
        usuario.perfil?.toLowerCase().includes(searchLower)
      );
    }
    
    if (this.sortColumn) {
      this.applySorting();
    }
  }

  hasActiveFilters(): boolean {
    if (!this.activeFilters) return false;
    const hasRoleFilter = !this.activeFilters.allRoles && 
      Object.values(this.activeFilters.roles).some(val => val === true);
    const hasStatusFilter = !this.activeFilters.allStatuses && 
      Object.values(this.activeFilters.statuses).some(val => val === true);
    const hasLoginFilter = this.activeFilters.lastLogin !== 'all';
    
    return hasRoleFilter || hasStatusFilter || hasLoginFilter;
  }

  clearFilters(): void {
    this.activeFilters = null;
    this.searchTerm = '';
    this.sortColumn = '';
    this.sortDirection = 'asc';
    this.initializeFilters();
    this.usuariosFiltrados = [...this.usuarios];
    this.alertService.success('Filtros limpiados', 'Los filtros han sido limpiados');
  }


  formatearRUTParaMostrar(rut: string): string {
    if (!rut) return '';
    
    let rutLimpio = rut.replace(/[\.\-]/g, '');
    
    if (rutLimpio.length <= 1) return rutLimpio;
    
    let cuerpo = rutLimpio.slice(0, -1);
    let dv = rutLimpio.slice(-1).toUpperCase();
    
    let cuerpoFormateado = '';
    for (let i = cuerpo.length - 1, j = 1; i >= 0; i--, j++) {
      cuerpoFormateado = cuerpo.charAt(i) + cuerpoFormateado;
      if (j % 3 === 0 && i !== 0) {
        cuerpoFormateado = '.' + cuerpoFormateado;
      }
    }
    
    return cuerpoFormateado + '-' + dv;
  }

  formatearRUT(): void {
    this.rutUsuarioFormateado = this.formatearRUTTexto(this.rutUsuarioFormateado);
  }

  formatearRUTTexto(rut: string): string {
    if (!rut) return '';

    let rutLimpio = rut.replace(/[^0-9kK]/g, '').toUpperCase();

    if (rutLimpio === '') return '';

    let cuerpo = rutLimpio.slice(0, -1);
    let dv = rutLimpio.slice(-1);

    if (cuerpo.length > 1) {
      let cuerpoFormateado = '';

      for (let i = cuerpo.length - 1, j = 1; i >= 0; i--, j++) {
        cuerpoFormateado = cuerpo.charAt(i) + cuerpoFormateado;
        if (j % 3 === 0 && i !== 0) {
          cuerpoFormateado = '.' + cuerpoFormateado;
        }
      }

      return cuerpoFormateado + '-' + dv;
    }

    return cuerpo + '-' + dv;
  }

  formatearRUTEnTiempoReal(): void {
    const inputElement = document.querySelector('input[name="rutUsuario"]') as HTMLInputElement;
    const cursorPosition = inputElement.selectionStart;
    const originalValue = this.rutUsuarioFormateado;
    const currentValue = this.rutUsuarioFormateado;
    const caracteresValidos = currentValue.replace(/[^0-9kK]/g, '');
    
    this.rutUsuarioFormateado = this.formatearRUTParaMostrar(caracteresValidos);
    
    setTimeout(() => {
      if (inputElement && cursorPosition !== null) {
        let newPosition = cursorPosition;
        const newValue = this.rutUsuarioFormateado;
        
        if (newValue.length > originalValue.length) {
          const addedChars = newValue.length - originalValue.length;
          newPosition += addedChars;
        }
        
        newPosition = Math.min(newPosition, newValue.length);
        inputElement.setSelectionRange(newPosition, newPosition);
      }
    }, 0);
  }

  limpiarRUT(rut: string): string {
    if (!rut) return '';
    
    rut = rut.replace(/\./g, '').replace(/\s/g, '');
    
    if (rut.includes('-')) {
      const partes = rut.split('-');
      if (partes.length === 2) {
        return partes[0] + '-' + partes[1].toUpperCase();
      }
    }
    
    if (rut.length > 1) {
      const cuerpo = rut.slice(0, -1);
      const dv = rut.slice(-1).toUpperCase();
      return cuerpo + '-' + dv;
    }
    
    return rut;
  }

  validarRUT(rut: string): boolean {
    if (!rut) return false;

    const rutLimpio = this.limpiarRUT(rut);
    const partes = rutLimpio.split('-');
    
    if (partes.length !== 2) return false;
    
    const cuerpo = partes[0];
    const dv = partes[1].toUpperCase();
    
    if (!/^\d+$/.test(cuerpo)) return false;
    if (!/^[0-9K]$/.test(dv)) return false;
    
    return true;
  }

  validarDigitoVerificador(cuerpo: string, dv: string): boolean {
    if (!cuerpo || cuerpo.length === 0) return false;

    let suma = 0;
    let multiplicador = 2;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      suma += parseInt(cuerpo.charAt(i)) * multiplicador;
      multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
    }

    const resto = suma % 11;
    let dvEsperado: string;

    if (resto === 0) {
      dvEsperado = '0';
    } else if (resto === 1) {
      dvEsperado = 'K';
    } else {
      dvEsperado = (11 - resto).toString();
    }

    return dv === dvEsperado;
  }

  actualizarDatosPersonales(): void {
    if (!this.validarRUT(this.rutUsuarioFormateado)) {
      this.mostrarMensaje('El RUT ingresado no es válido', 'error');
      return;
    }

    this.api.showLoading();

    const rutLimpio = this.limpiarRUT(this.rutUsuarioFormateado);

    const datosActualizados = {
      usuario_id: this.usuarioActivo.usuario_id,
      nombre: this.nombreUsuario,
      apellido: this.apellidoUsuario,
      email: this.emailUsuario,
      rut: rutLimpio, 
      compania: this.companiaUsuario,
      departamento: this.departamentoUsuario,
      rol:this.usuarioActivo.rol
    };

    this.api.updateUser(datosActualizados).subscribe({
      next: (response: any) => {
        this.api.hideLoading();
        this.mostrarMensaje('Datos personales actualizados correctamente', 'exito');
        this.sessionService.updateUserData(datosActualizados);
        this.rutUsuarioOriginal = rutLimpio;
        this.rutUsuarioFormateado = this.formatearRUTParaMostrar(rutLimpio);
      },
      error: (error) => {
        this.api.hideLoading();
        console.error('Error al actualizar datos personales', error);
        this.rutUsuarioFormateado = this.formatearRUTParaMostrar(this.rutUsuarioOriginal);

        if (error.error && error.error.message) {
          this.mostrarMensaje(`Error: ${error.error.message}`, 'error');
        } else {
          this.mostrarMensaje('Error al actualizar los datos personales', 'error');
        }
      },
    });
  }

  public generarAlias(nombre: string = '', apellido: string = ''): string {
    const primeraLetra = nombre && nombre.length > 0 ? nombre.charAt(0).toLowerCase() : '';
    const apellidoFormateado = apellido ? apellido.toLowerCase().replace(/\s+/g, '') : '';
    return primeraLetra + apellidoFormateado;
  }

  public obtenerPerfilPorRolId(rolId: string): string {
    if (!rolId) return 'Sin perfil';

    const rolIdLower = rolId.toLowerCase();

    if (rolIdLower.endsWith('6d78')) {
      return 'Administrator';
    } else if (rolIdLower.endsWith('cf52')) {
      return 'Ejecutivo comercial';
    } else {
      return 'Ejecutivo comercial';
    }
  }

  toggleUsuarioActivo(usuario: any): void {
    const nuevoEstado = usuario.activo === 1 ? 0 : 1;
    usuario.activo = nuevoEstado;
    usuario.estado = nuevoEstado === 1 ? 'Activo' : 'Inactivo';
  }

  mostrarTablaUsuarios() {
    this.mostrarTabla = true;
  }

  cambiarVista(vista: string) {
  if (this.vistaActual === 'datos' && this.hayCambiosNoGuardados()) {
    const confirmar = confirm('Tienes cambios sin guardar. ¿Deseas salir de todos modos?');
    if (!confirmar) return;
  }

  if (this.vistaActual === 'datos' && vista !== 'datos') {
    this.nombreUsuario = '';
    this.apellidoUsuario = '';
    this.emailUsuario = '';
    this.rutUsuarioFormateado = '';
    this.companiaUsuario = '';
    this.departamentoUsuario = '';
  }

  this.vistaActual = vista;

  if (vista === 'datos') {
    this.api.getUserProfile().subscribe({
      next: (res: any) => {
        if (res && res.data) {
          this.usuarioActivo = res.data;
          this.procesarDatosUsuario();  
          this.guardarDatosOriginales(); 
        }
      },
      error: (err) => {
        console.error('❌ Error recargando perfil:', err);
      },
    });
  }

  if (vista === 'cambiar-contrasena') {
    this.cargarDatosUsuarioActivo();
  }

  switch (vista) {
    case 'usuarios':
      this.cargarUsuarios();
      break;
    case 'datos':
      break;
    case 'correo':
      break;
  }
}


  openMdlCreateUser() {
    this.dialog.open(MdlCreateUserComponent, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: { mode: 'create', type: 'user' },
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.cargarUsuarios();
      }
    });
  }

  updateUser(usuario: any): void {
    this.usuarioSeleccionado = { ...usuario };
    this.cargarPermisosUsuario(usuario);
    this.mostrarModificarUsuario = true;
  }

  volverATablaUsuarios(): void {
    this.mostrarModificarUsuario = false;
    this.usuarioSeleccionado = null;
  }

  validarContrasena() {
    if (this.contrasenaActual && this.contrasenaActualError) {
      this.contrasenaActualError = '';
    }

    this.cumpleLongitud = this.nuevaContrasena.length >= 8;
    this.cumpleMayuscula = /[A-Z]/.test(this.nuevaContrasena);
    this.cumpleNumero = /\d/.test(this.nuevaContrasena);
    this.cumpleEspecial = /[^A-Za-z0-9]/.test(this.nuevaContrasena);
    this.contrasenasCoinciden = this.nuevaContrasena === this.confirmarContrasena && this.nuevaContrasena !== '';
    this.mostrarRequisitos = this.nuevaContrasena !== '';

    this.formularioContrasenaValido = this.contrasenaActual !== '' &&
      this.nuevaContrasena !== '' &&
      this.confirmarContrasena !== '' &&
      this.cumpleLongitud &&
      this.cumpleMayuscula &&
      this.cumpleNumero &&
      this.cumpleEspecial &&
      this.contrasenasCoinciden;
  }

  toggleSeleccionUsuario(usuario: any, event: any): void {
    const usuarioId = usuario.usuario_id;
    if (event.target.checked) {
      this.usuariosConSeleccion.add(usuarioId);
    } else {
      this.usuariosConSeleccion.delete(usuarioId);
    }
    this.usuariosSeleccionados = this.usuariosConSeleccion.size;
  }

  toggleSeleccionTodos(event: any): void {
    if (event.target.checked) {
      this.usuariosFiltrados.forEach((usuario) => {
        if (usuario.usuario_id) {
          this.usuariosConSeleccion.add(usuario.usuario_id);
        }
      });
    } else {
      this.usuariosConSeleccion.clear();
    }
    this.usuariosSeleccionados = this.usuariosConSeleccion.size;
  }

  isUsuarioSeleccionado(usuarioId: string): boolean {
    return this.usuariosConSeleccion.has(usuarioId);
  }

  get todosSeleccionados(): boolean {
    if (this.usuariosFiltrados.length === 0) return false;
    return this.usuariosFiltrados.every((usuario) => usuario.usuario_id && this.usuariosConSeleccion.has(usuario.usuario_id));
  }

  toggleActionsDropdown(): void {
    this.showActionsDropdown = !this.showActionsDropdown;
  }

  ejecutarAccion(accion: string): void {
    console.log(`Acción seleccionada: ${accion} para ${this.usuariosSeleccionados} usuarios`);
    const usuariosIds = Array.from(this.usuariosConSeleccion);

    if (usuariosIds.length === 0) {
      this.mostrarMensaje('No hay usuarios seleccionados', 'advertencia');
      this.showActionsDropdown = false;
      return;
    }

    switch (accion) {
      case 'eliminar':
        if (usuariosIds.length === 1) {
          const usuarioId = usuariosIds[0];
          const usuario = this.usuarios.find((u) => u.usuario_id === usuarioId);
          if (usuario) {
            this.openMdlDeleteUser(usuario);
          }
        } else {
          this.eliminarUsuarios(usuariosIds);
        }
        break;
      case 'desactivar':
        this.desactivarUsuarios(usuariosIds);
        break;
      case 'activar':
        this.activarUsuarios(usuariosIds);
        break;
    }

    this.showActionsDropdown = false;
  }

  activarUsuarios(usuariosIds: string[]): void {
    this.openStatusModal(usuariosIds, 'activate');
  }

  desactivarUsuarios(usuariosIds: string[]): void {
    this.openStatusModal(usuariosIds, 'deactivate');
  }

  private openStatusModal(usuariosIds: string[], action: 'activate' | 'deactivate'): void {
    if (usuariosIds.length === 1) {
      const usuarioId = usuariosIds[0];
      const usuario = this.usuarios.find((u) => u.usuario_id === usuarioId);
      if (usuario) {
        this.openUserStatusModal(usuario, action);
        return;
      }
    }

    const dialogRef = this.dialog.open(MdlDeleteUserComponent, {
      minWidth: '500px',
      minHeight: '260px',
      panelClass: 'mat-dlg-class',
      data: { action: action, mode: 'multiple-users', userIds: usuariosIds, count: usuariosIds.length },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.action) {
        this.cambiarEstadoUsuarios(result.userIds, result.action === 'activate' ? 1 : 0);
      }
    });
  }

  private openUserStatusModal(usuario: any, action: string): void {
    const dialogRef = this.dialog.open(MdlDeleteUserComponent, {
      minWidth: '500px',
      minHeight: '260px',
      panelClass: 'mat-dlg-class',
      data: {
        action: action,
        mode: 'user',
        id: usuario.usuario_id,
        nombre: usuario.nombre,
        apellido: usuario.apellido,
        email: usuario.email,          
        rut: usuario.rut || '',        
        rolId: usuario.rolId || usuario.rol?.id || 1, 
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.success) {
        const usuarioIndex = this.usuarios.findIndex((u) => u.usuario_id === usuario.usuario_id);
        if (usuarioIndex !== -1) {
          this.usuarios[usuarioIndex].activo = result.newStatus;
          this.usuarios[usuarioIndex].estado = result.newStatus === 1 ? 'Activo' : 'Inactivo';
        }
        this.mostrarMensaje(`Usuario ${action === 'activate' ? 'activado' : 'desactivado'} correctamente`, 'exito');
        this.limpiarSeleccion();
      }
    });
  }

 cambiarEstadoUsuarios(usuariosIds: string[], nuevoEstado: number): void {
  if (!usuariosIds.length) return;

  const payload = usuariosIds.map((userId) => ({
    usuario_id: userId,
    activo: nuevoEstado
  }));

  console.log('📦 Payload enviado al backend:', payload);

  this.api.showLoading();

  this.api.updateUserStatusBatch(payload).subscribe({
    next: (res: any) => {
      this.api.hideLoading();
      console.log('✅ Estados de usuarios actualizados correctamente', res);

      this.usuarios.forEach((usuario) => {
        if (usuariosIds.includes(usuario.usuario_id)) {
          usuario.activo = nuevoEstado;
          usuario.estado = nuevoEstado === 1 ? 'Activo' : 'Inactivo';
        }
      });

      this.mostrarMensaje(
        `Usuarios ${nuevoEstado === 1 ? 'activados' : 'desactivados'} correctamente`,
        'exito'
      );
      this.limpiarSeleccion();
    },
    error: (error) => {
      this.api.hideLoading();
      console.error('❌ Error al cambiar estado de usuarios', error);
      this.mostrarMensaje('Error al cambiar el estado de algunos usuarios', 'error');
    }
  });
}


  eliminarUsuarios(usuariosIds: string[]): void {
    const dialogRef = this.dialog.open(MdlDeleteUserComponent, {
      minWidth: '500px',
      minHeight: '260px',
      panelClass: 'mat-dlg-class',
      data: { mode: 'multiple-users', userIds: usuariosIds, count: usuariosIds.length },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.api.showLoading();
        const requests = usuariosIds.map((userId) => {
          return this.api.deleteUser({ usuario_id: userId }).toPromise();
        });

        Promise.all(requests).then((responses) => {
          this.api.hideLoading();
          console.log('Usuarios eliminados correctamente', responses);
          this.usuarios = this.usuarios.filter((usuario) => !usuariosIds.includes(usuario.usuario_id));
          this.mostrarMensaje('Usuarios eliminados correctamente', 'exito');
          this.limpiarSeleccion();
          this.cargarUsuarios();
        }).catch((error) => {
          this.api.hideLoading();
          console.error('Error al eliminar usuarios', error);
          this.mostrarMensaje('Error al eliminar algunos usuarios', 'error');
        });
      }
    });
  }

  limpiarSeleccion(): void {
    this.usuariosConSeleccion.clear();
    this.usuariosSeleccionados = 0;
    this.showActionsDropdown = false;
  }

  cancelarCambioContrasena() {
    this.contrasenaActual = '';
    this.nuevaContrasena = '';
    this.confirmarContrasena = '';
    this.mostrarRequisitos = false;
    this.cambiarVista('usuarios');
  }

  cambiarContrasena() {
    if (!this.usuarioActivo?.usuario_id) {
      this.mostrarMensaje('Error: Usuario no identificado', 'error');
      return;
    }

    if (!this.contrasenaActual) {
      this.contrasenaActualError = 'La contraseña actual es requerida';
      this.mostrarMensaje('Debe ingresar la contraseña actual', 'error');
      return;
    }

    if (!this.formularioContrasenaValido) {
      this.mostrarMensaje('Por favor, complete todos los campos correctamente', 'error');
      return;
    }

    this.ambiandoContrasena = true;
    const payload = {
      usuario_id: this.usuarioActivo.usuario_id,
      contrasenaActual: this.contrasenaActual,
      nuevaContrasena: this.nuevaContrasena,
    };

    console.log('Realizando llamada HTTP...');
    this.api.changePassword(payload).subscribe({
      next: (response: any) => {
        this.ambiandoContrasena = false;
        this.mostrarMensaje('Contraseña cambiada exitosamente', 'exito');
        this.contrasenaActual = '';
        this.nuevaContrasena = '';
        this.confirmarContrasena = '';
        this.mostrarRequisitos = false;
        this.ultimoCambioContrasena = new Date();
      },
      error: (error) => {
        console.error('❌ Error en la llamada HTTP:', error);
        this.ambiandoContrasena = false;
        if (error.status === 401) {
          this.contrasenaActualError = 'Contraseña actual incorrecta';
          this.mostrarMensaje('La contraseña actual es incorrecta', 'error');
        } else if (error.status === 400) {
          this.mostrarMensaje('La nueva contraseña no cumple con los requisitos', 'error');
        } else if (error.error && error.error.message) {
          this.mostrarMensaje(`Error: ${error.error.message}`, 'error');
        } else {
          this.mostrarMensaje('Error de conexión con el servidor', 'error');
        }
      },
    });
  }

  cargarPermisosUsuario(usuario: any) {
    this.api.getUserPermissions({ usuario_id: usuario.usuario_id }).subscribe((res: any) => {
      if (res?.success) {
        this.modulos.forEach(m => {
          this.permisosUsuario[m.modulo] = {};
          m.acciones.forEach(a => this.permisosUsuario[m.modulo][a] = false);
        });

        Object.keys(res.permisos || {}).forEach((modulo: string) => {
          res.permisos[modulo].forEach((accion: string) => {
            if (this.permisosUsuario[modulo]) {
              this.permisosUsuario[modulo][accion] = true;
            }
          });
        });
      }
    }, error => {
      console.error("Error al cargar permisos:", error);
    });
  }

  togglePermiso(modulo: string, accion: any) {
    this.permisosUsuario[modulo][accion] = !this.permisosUsuario[modulo][accion];
  }

  guardarCambiosUsuario(): void {
    console.log('Guardando cambios:', this.usuarioSeleccionado);
    this.api.showLoading();
  
    const userData: any = {
      usuario_id: this.usuarioSeleccionado.usuario_id,
      rut: this.usuarioSeleccionado.rut || '',
      nombre: this.usuarioSeleccionado.nombre,
      apellido: this.usuarioSeleccionado.apellido,
      email: this.usuarioSeleccionado.email,
      contrasena: this.usuarioSeleccionado.contrasena || undefined,
      rolId: this.usuarioSeleccionado.rolId || this.usuarioSeleccionado.rol?.rolId,
      activo: this.usuarioSeleccionado.activo ? 1 : 0,
      permisos: this.permisosUsuario
    };
  
    Object.keys(userData).forEach(key => {
      if (userData[key] === undefined) delete userData[key];
    });
  
    const newPass = this.usuarioSeleccionado?.nuevaContrasena;
  
    this.api.updateUser(userData).subscribe({
      next: () => {
        if (newPass) {
          this.api.adminResetPassword({
            usuario_id: this.usuarioSeleccionado.usuario_id,
            nuevaContrasena: newPass
          }).subscribe({
            next: () => this.mostrarMensaje('Contraseña actualizada', 'exito'),
            error: () => this.mostrarMensaje('Error al actualizar contraseña', 'error')
          });
        }
  
        this.api.hideLoading();
        this.mostrarMensaje('Usuario actualizado correctamente', 'exito');
        this.volverATablaUsuarios();
        this.cargarUsuarios();
  
        setTimeout(() => {
          window.location.reload();
        }, 500);
      },
      error: (error) => {
        this.api.hideLoading();
        console.error('Error al actualizar usuario', error);
        this.mostrarMensaje('Error al actualizar el usuario', 'error');
      }
    });
  }
  

  openMdlDeleteUser(usuario: any) {
    this.dialog.open(MdlDeleteUserComponent, {
      minWidth: '500px',
      minHeight: '260px',
      panelClass: 'mat-dlg-class',
      data: {
        action: 'delete',
        mode: 'user',
        id: usuario.usuario_id,
        nombre: usuario.nombre,
        apellido: usuario.apellido,
      },
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.usuarios = this.usuarios.filter((u) => u.usuario_id !== usuario.usuario_id);
        this.mostrarMensaje('Usuario eliminado correctamente', 'exito');
        this.limpiarSeleccion();
        this.cargarUsuarios();
      }
    });
  }

  openMdlChangeOwner(usuario: any) {
    this.dialog.open(MdlChangeBudgetComponent, {
      minWidth: '750px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: { userData: usuario, type: 'user' },
    }).afterClosed().subscribe((result) => {
      if (result) {
        this.cargarUsuarios();
      }
    });
  }

  toggleRecentDropdown(): void {
    this.showRecentDropdown = !this.showRecentDropdown;
  }

selectItem(key: string): void {
  this.selectedItem = key;
  this.showRecentDropdown = false;

  if (key === 'activos') {
    this.usuariosFiltrados = this.usuarios.filter((user) => user.activo === 1);
  } else {
    this.usuariosFiltrados = [...this.usuarios];
  }

  if (this.sortColumn) {
    this.applySorting();
  }
}

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false;
  }

  verDetalleUsuario(id: string, event?: MouseEvent) {
    if (event) {
      const target = event.target as HTMLElement;
      const isCheckbox = target.tagName === 'INPUT' && target.getAttribute('type') === 'checkbox';
      const isDropdown = target.closest('.dropdown-container') !== null;
      if (isCheckbox || isDropdown) {
        return;
      }
    }
    this.mostrarMensaje('Funcionalidad de detalle en desarrollo', 'advertencia');
  }

  mostrarMensaje(mensaje: string, tipo: 'exito' | 'error' | 'advertencia'): void {
    switch (tipo) {
      case 'exito':
        this.alertService.success('Éxito', mensaje);
        break;
      case 'error':
        this.alertService.error('Error', mensaje);
        break;
      case 'advertencia':
        this.alertService.warning('Advertencia', mensaje);
        break;
    }
  }

  getOulookMail(){
    this.api.getOutlookInfo().subscribe({
      next: (response: any) => {
        if(response.success){
          this.outlookMail = response.outlook_account_email;
        }
      },
      error: (error) => {
        console.error('Error al obtener correo de Outlook:', error);
      },
    });
  }

  openUnlinkMdl(){
    const dialogRef = this.dialog.open(MdlUnlinkOutlook, {
      minWidth: '500px',
      maxHeight: '400px',
      panelClass: 'mat-dlg-class',
      data: {
        email: this.outlookMail
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Resultado del diálogo de desvinculación:', result);
      if (result) {
        this.outlookMail = '';
        this.alertService.success('Exito', 'Tu cuenta de Outlook ha sido desvinculada correctamente.');
      }
    }); 
  }

  connectOutlook() {
    const tenantId = "7eafb56d-40c8-4934-842a-c9207647bbe0";
    const clientId = "25fe7f5a-a0f1-47b2-869b-b2d671126a72";
    const redirectUri = "https://crm-tic-back-29ydx.ondigitalocean.app/api/auth/callback"; // backend
    const scopes = [
      "openid",
      "profile",
      "offline_access",
      "User.Read",
      "Mail.Send",
      "Calendars.Read"
    ];

    // Tu JWT local (ejemplo: guardado en localStorage después del login en tu app)
    const jwtLocal = localStorage.getItem("crmtoken");

    // Armamos la URL
    const authUrl =
      `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize` +
      `?client_id=${clientId}` +
      `&response_type=code` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&response_mode=query` +
      `&scope=${encodeURIComponent(scopes.join(" "))}` +
      `&state=${encodeURIComponent(jwtLocal ?? '')}`;

    // Redirigir al usuario
    window.location.href = authUrl;
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null): void {
    if (!(target instanceof HTMLElement)) return;

    const clickedInsideRecent = this.elementRef.nativeElement.querySelector('.dropdown-trigger')?.contains(target);
    const clickedInsideActions = this.elementRef.nativeElement.querySelector('.dots-button')?.contains(target);

    if (!clickedInsideRecent) {
      this.showRecentDropdown = false;
    }

    if (!clickedInsideActions) {
      this.openedMenuId = null;
    }
  }

  private guardarDatosOriginales(): void {
  this.datosOriginales = {
    nombreUsuario: this.nombreUsuario,
    apellidoUsuario: this.apellidoUsuario,
    emailUsuario: this.emailUsuario,
    rutUsuarioFormateado: this.rutUsuarioFormateado,
    companiaUsuario: this.companiaUsuario,
    departamentoUsuario: this.departamentoUsuario,
  };
}


private hayCambiosNoGuardados(): boolean {
  return (
    this.nombreUsuario !== this.datosOriginales.nombreUsuario ||
    this.apellidoUsuario !== this.datosOriginales.apellidoUsuario ||
    this.emailUsuario !== this.datosOriginales.emailUsuario ||
    this.rutUsuarioFormateado !== this.datosOriginales.rutUsuarioFormateado ||
    this.companiaUsuario !== this.datosOriginales.companiaUsuario ||
    this.departamentoUsuario !== this.datosOriginales.departamentoUsuario
  );
}

 getRoles(){
    this.api.getRol().subscribe({
      next: (response: any) => {
        this.rolesDisponibles=response.roles
      }})
  }

}